var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnSmallRefresh = function SvgIcnSmallRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5v1.492c0 .375.45.558.709.291l2.325-2.325a.413.413 0 0 0 0-.591l-2.325-2.325a.417.417 0 0 0-.709.3v1.491A6.665 6.665 0 0 0 3.333 10c0 .867.167 1.7.475 2.458a.835.835 0 0 0 1.367.284.8.8 0 0 0 .192-.867A4.853 4.853 0 0 1 5 10c0-2.758 2.242-5 5-5Zm4.825 2.258c-.225.225-.316.575-.191.867.233.583.366 1.217.366 1.875 0 2.758-2.242 5-5 5v-1.492a.412.412 0 0 0-.708-.291l-2.325 2.325a.412.412 0 0 0 0 .591l2.325 2.325a.416.416 0 0 0 .708-.291v-1.5A6.665 6.665 0 0 0 16.667 10c0-.867-.167-1.7-.475-2.458a.835.835 0 0 0-1.367-.284Z",
    fill: "#292525"
  })));
};
export default SvgIcnSmallRefresh;